// Shared viewport breakpoints. Single source of truth for the JS-side
// matchMedia consumers (sidebar store, useMediaQuery composable). The CSS
// mirrors are the --bp-* tokens in styles/tokens.css and the literal pixel
// values in the @media/@container blocks - CSS media queries can't read a
// custom property, so the numbers live in both places by necessity. Keep them
// in sync: change here AND in the CSS when a breakpoint moves.
//
//   sm (480) - phone boundary. Below it the side-nav becomes an off-canvas
//              drawer (AppShell) and content drops its desktop chrome.
//   md (960) - rail boundary. Below it the nav auto-collapses to the 48px
//              icon rail (sidebar store).
export const BP_SM_PX = 480;
export const BP_MD_PX = 960;

// matchMedia strings for "viewport is below this breakpoint". The -0.02px is
// the standard fractional guard so `max-width` and a later `min-width` query
// never both match at the exact integer boundary.
export const BELOW_SM = `(max-width: ${BP_SM_PX - 0.02}px)`;
export const BELOW_MD = `(max-width: ${BP_MD_PX - 0.02}px)`;
